module.exports = __webpack_public_path__ + "static/media/arrow-down-grey-solid.93e0fcb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down-grey-solid.svg
// module id = 250
// module chunks = 0